import { useState } from 'react';
import { ScheduleData } from '../../hook/ScheduleData.js';
import ScheduleCard from '../ScheduleComponent/ScheduleCard.jsx';
import './ScheduleFull.css';

function ScheduleTable() 
{
  const [filter, setFilter] = useState('all'); // 'all' | 'vo' | 'spo'

  const voData  = ScheduleData('/ScheduleAll', null, true);
  const spoData = ScheduleData('/ScheduleAll', null, false);

  const loading = voData.loading || spoData.loading;
  const error   = voData.error   || spoData.error;

  if (loading) return <div className='loading'>Загрузка расписания...</div>;
  if (error)   return <div className='error'>Ошибка: {error}</div>;

  const combined = filter === 'vo'  ? voData.data
                 : filter === 'spo' ? spoData.data
                 : [...(voData.data || []), ...(spoData.data || [])];

  return (
    <div>
      <div className='edu-filter'>
        <button 
          className={`edu-filter__btn ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          Все
        </button>
        <button 
          className={`edu-filter__btn vo ${filter === 'vo' ? 'active' : ''}`}
          onClick={() => setFilter('vo')}
        >
          Высшее образование (ВО)
        </button>
        <button 
          className={`edu-filter__btn spo ${filter === 'spo' ? 'active' : ''}`}
          onClick={() => setFilter('spo')}
        >
          СПО
        </button>
      </div>
      <ScheduleCard scheduleData={combined} />
    </div>
  );
}

export default ScheduleTable;
